<template>
  <v-card class="rounded-b-0">
    <v-card-title class="align-start">
      <span>Total No. of Tissue and Transplant </span>

      <v-spacer></v-spacer>

     
    </v-card-title>

    <v-card-text>
      
     
       <div id="pie-chart"></div>
     
    </v-card-text>
  </v-card>
</template>

<script>

import { mdiDotsVertical, mdiTrendingUp, mdiCurrencyUsd } from '@mdi/js'
import daskboardserice from '@/service/Dashboard.service'
import moment from 'moment'
export default {

  setup() {
    

    return {

      icons: {
        mdiDotsVertical,
        mdiTrendingUp,
        mdiCurrencyUsd,
      },
    }
  },
   
   
   watch: {
    options: {
      handler() {
        this.chartMap()
      },
      deep: true,
    },
  },
  mounted() {
    this.chartMap()

  },
  methods:{

    async chartMap(){
      const service = new daskboardserice()
      let response = await service.getDaskboard()
      var data12 = response
      // console.log("hello daaaaaaaa", data12)
      var total_no_tissue = data12.total_no_tissue
      var total_no_transplant = data12.total_no_transplant
      
      const arr =[]
     
      arr[0]=total_no_tissue
      arr[1]=total_no_transplant
    
      var options = {
          series: arr,
          chart: {
          width: 440,
          type: 'pie',
        },
        colors:['#1bbc9b', '#00e396'],
        labels: ['Tissue', 'transplant'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
        };

        var pir_chart = new ApexCharts(document.querySelector("#pie-chart"), options);
        pir_chart.render();
    }
  }
}
</script>
